import {
    Box,
    Flex,
    Heading,
} from "@chakra-ui/react";
import { StatesTable } from "../../components/states-table/states-table.comp";

export function StatesList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>States</Heading>
            </Flex>
            <StatesTable />
        </Box>
    );
}
